import { SelectOption } from 'global';
import { SendVia } from '../types';

export const sendViaOptions: SelectOption<SendVia>[] = [
  { label: 'Email', value: SendVia.Email },
  { label: 'Text', value: SendVia.Text },
  { label: 'Text and email', value: SendVia.TextAndEmail },
];
